/**
 * @license Copyright (c) 2006 Greenwood Mapping, Inc.
 * March 26, 2006
 * cscs.js is loosely based on the PROJ.4 program cs2cs
 */

export const CSCS = {  // named export, use with "import {CSCS} from './CSCS.js';"


  list: {
    EPSG4326: "+title=long / lat WGS84 +proj=longlat"  // +a=6378137.0 +b=6356752.31424518" //  +ellps=WGS84 +datum=WGS84"
    // EPSG4269: "+title=long / lat NAD83 +proj=longlat"   // +a=6378137.0 +b=6356752.31414036" //  +ellps=GRS80 +datum=NAD83"
  },

  /**
   * Point constructor
   * @constructor
   */
  PT: function (x, y) {
    if (Array.isArray(x)) {
      this.x = x[0];
      this.y = x[1];
    } else if (typeof x === 'object' && x.lng) {  // for Leaflet
      this.x = x.lng;
      this.y = x.lat;
    } else if (typeof x === 'object' && x.longitude) {  // for HTML navigator.geolocation
      this.x = x.longitude;
      this.y = x.latitude;
    } else {
      this.x = x;
      this.y = y;
    }
    this.z = 0.0;
  },

  /**
   * Coordinate System constructor
   * @constructor
   */
  CS: function(def)  {
    if(!def) {  // def is optional, if not provided, default to longlat WGS84
      def = CSCS.list.EPSG4326;
      CSCS.ErrorMessage += 'No coordinate system definition provided, assuming longlat WGS83';
    }

    var
      paramName,
      paramVal,
      paramArray = def.split("+"),
      prop,
      property,
      i;

    for (prop = 0; prop < paramArray.length; prop++) {
      property = paramArray[prop].split("=");
      paramName= property[0].toLowerCase();
      paramVal = property[1];

      switch (paramName.replace(/\s/gi,"")) {  // trim out spaces
        case "": break;   // throw away nameless parameter
        case "title": this.title = paramVal; break;
        case "proj": this.proj = paramVal.replace(/\s/gi,""); break;
        // case "ellps": this.ellps = paramVal.replace(/\s/gi,""); break;
        // case "datum": this.datum = paramVal.replace(/\s/gi,""); break;
        case "a":      this.a =  parseFloat(paramVal);  break; // semi-major radius
        case "b":      this.b =  parseFloat(paramVal);  break; // semi-minor radius
        case "lon_0":  this.long0= paramVal*CSCS.D2R; break;   // lam0, central longitude
        case "lat_0":  this.lat0 = paramVal*CSCS.D2R; break;   // phi0, central latitude
        case "lat_1":  this.lat1 = paramVal*CSCS.D2R; break;   // Used in Lambert Conformal Conic
        case "lat_2":  this.lat2 = paramVal*CSCS.D2R; break;   // Used in Lambert Conformal Conic
        case "lat_ts": this.phits  = paramVal*CSCS.D2R; break; // latitude_of_origin
        case "x_0":    this.x0 = parseFloat(paramVal); break;  // false easting
        case "y_0":    this.y0 = parseFloat(paramVal); break;  // false northing
        case "k":      this.k0 = parseFloat(paramVal); break;  // projection scale factor
        case "to_meter": this.to_meter = parseFloat(paramVal); break; // cartesian scaling
        case "zone":     this.zone =  parseInt(paramVal, 10); break;      // UTM Zone
        case "towgs84":  this.datum_params = paramVal.split(","); break;
        case "from_greenwich": this.from_greenwich = paramVal*CSCS.D2R; break;
        default: CSCS.ErrorMessage += "\nUnrecognized parameter: " + paramName;
      } // switch()
    } // for paramArray


    if (this.datum_params)  {
      for (i=0; i<this.datum_params.length; i++) {
        this.datum_params[i]=parseFloat(this.datum_params[i]);
      }
      if (this.datum_params[0] !== 0 ||
          this.datum_params[1] !== 0 ||
          this.datum_params[2] !== 0 ) {
        this.datum_type = CSCS.D_3PARAM;
      }
      if (this.datum_params.length > 3) {
        if (this.datum_params[3] !== 0 ||
            this.datum_params[4] !== 0 ||
            this.datum_params[5] !== 0 ||
            this.datum_params[6] !== 0 ) {
          this.datum_type = CSCS.D_7PARAM;
          this.datum_params[3] *= CSCS.SEC_TO_RAD;
          this.datum_params[4] *= CSCS.SEC_TO_RAD;
          this.datum_params[5] *= CSCS.SEC_TO_RAD;
          this.datum_params[6] = (this.datum_params[6]/1000000.0) + 1.0;
        }
      }
    }

    if (!this.datum_type) {
      this.datum_type = CSCS.D_WGS84;
    }

    /* ********************
      should look for errors here,
       required for longlat:
        proj, datum_type
       additional requirements for projected CSs:
        Forward(), Inverse(), Inint()
    ********************* */

    if (!this.a) {    // do we have an ellipsoid?
      this.a = 6378137.0;
      this.b = 6356752.31424518;
      CSCS.ErrorMessage += "\nEllipsoid parameters not provided, assuming WGS84";
    }
    this.a2 = this.a * this.a;          // used in geocentric
    this.b2 = this.b * this.b;          // used in geocentric
    this.es=(this.a2-this.b2)/this.a2;  // e ^ 2
    // this.es=1-(Math.pow(this.b,2)/Math.pow(this.a,2));
    this.e = Math.sqrt(this.es);        // eccentricity
    this.ep2=(this.a2-this.b2)/this.b2; // used in geocentric

    if (this.proj !== "longlat") {  // The Forward, Inverse, and Initilization function names are derived from the projection name.
      this.Forward = CSCS[this.proj].fwd;
      this.Inverse = CSCS[this.proj].inv; // name of inverse function (x/y to long/lat)
      this.Init  =  CSCS[this.proj].init; // initilization function, would be nice as 'new' constructor
      this.Init(this);  // run the initilization which adds various constants to 'this'
    }

  }, // CS constructor


  /**
   * @param {CSCS.CS} srcdefn source coordinate system
   * @param {CSCS.CS} dstdefn destination coordinate system
   * @param {CSCS.PT} p       any object with x & y properties
   * @param {boolean} keep    optional, keep the x, y values of p or replace them, default = false
   * returns a new CSCS.PT or pj_errno
   */
  transform: function(srcdefn, dstdefn, p, keep) {
    var pj_errno = 0;
    var point = new CSCS.PT(p.x, p.y);
    if (srcdefn.title !== dstdefn.title) {
      // Transform source points to long/lat, if they aren't already.
      if (srcdefn.proj === "longlat") {
        point.x *= CSCS.D2R;  // convert degrees to radians
        point.y *= CSCS.D2R;
      } else {
        if (srcdefn.to_meter) {
          point.x *= srcdefn.to_meter;
          point.y *= srcdefn.to_meter;
        }
        srcdefn.Inverse(point); // Convert Cartesian to longlat
      }

      // Adjust for the prime meridian if necessary
      if (srcdefn.from_greenwich) { point.x += srcdefn.from_greenwich; }

      // do we need to convert datums?
      if (!CSCS.datumsEqual(srcdefn, dstdefn)) {
        // is datumTransform code loaded?
        if (typeof(CSCS.datumTransform) === 'function') {
          if (!CSCS.datumTransform( srcdefn, dstdefn, point)) {
            window.alert('dataum transform failed' + CSCS.ErrorMessage);
          }
        } else {
          window.alert('Warning: A datum transformation is required\nbut datum transformation code is not loaded.\nNo datum transformation will be applied.');
        }
      }

      // Adjust for the prime meridian if necessary
      if (dstdefn.from_greenwich ) { point.x -= dstdefn.from_greenwich; }

      if (dstdefn.proj === "longlat" ) {  // convert radians to decimal degrees
        point.x *=CSCS.R2D;
        point.y *=CSCS.R2D;
      } else {  // else project
        dstdefn.Forward(point);
        if (dstdefn.to_meter) {
        point.x /= dstdefn.to_meter;
        point.y /= dstdefn.to_meter;
        }
      }
    }
    if (!keep) {
      p.x = point.x;
      p.y = point.y;
      p.z = point.z;
    }
    return pj_errno || point;
  }, // transform()

  // Returns 1 (true) if the two datums match, otherwise 0 (false).
  datumsEqual: function(srcdefn, dstdefn) {
    if (srcdefn.datum_type !== dstdefn.datum_type) {
      return 0; // false, datums are not equal
    } else if (srcdefn.datum_type === CSCS.D_3PARAM) {
      return (srcdefn.datum_params[0] === dstdefn.datum_params[0]
              && srcdefn.datum_params[1] === dstdefn.datum_params[1]
              && srcdefn.datum_params[2] === dstdefn.datum_params[2]);
    } else if  (srcdefn.datum_type === CSCS.D_7PARAM) {
      return (srcdefn.datum_params[0] === dstdefn.datum_params[0]
              && srcdefn.datum_params[1] === dstdefn.datum_params[1]
              && srcdefn.datum_params[2] === dstdefn.datum_params[2]
              && srcdefn.datum_params[3] === dstdefn.datum_params[3]
              && srcdefn.datum_params[4] === dstdefn.datum_params[4]
              && srcdefn.datum_params[5] === dstdefn.datum_params[5]
              && srcdefn.datum_params[6] === dstdefn.datum_params[6]);
    } else if ( srcdefn.datum_type === CSCS.D_GRIDSHIFT ) {
      // don't have support for gridshifts in CSCS yet
      // strcmp is not defined
      // pj_param is not defined
      // return strcmp(pj_param(srcdefn.params,"snadgrids").s,
      //               pj_param(dstdefn.params,"snadgrids").s ) === 0;
      return 0; // false
    } else {
      return 1; // true, datums are equal
    }
  }, // datumsEqual()


  // Constants
  /** @const */ PI: Math.PI,
  /** @const */ HALF_PI: Math.PI*0.5,
  /** @const */ TWO_PI: Math.PI*2,
  /** @const */ R2D: 57.2957795131,
  /** @const */ D2R: 0.0174532925199,
  /** @const */ SEC_TO_RAD: 4.84813681109535993589914102357e-6, // SEC_TO_RAD: Pi/180/3600
  /** @const */ EPSLN: 1.0e-10,
  /** @const */ EPS10: 1.e-10,
  /** @const */ SRS_WGS84_SEMIMAJOR: 6378137.0,  // only used in grid shift transforms
  /** @const */ FORTPI : 0.78539816339744833,

  /* datum_type values */
  /** @const */ D_UNKNOWN:   0,
  /** @const */ D_3PARAM:    1,
  /** @const */ D_7PARAM:    2,
  /** @const */ D_GRIDSHIFT: 3,
  /** @const */ D_WGS84:     4,  // WGS84 or equivelent

  ErrorMessage: "Message: ",

  // return the sign of an argument
  sign: function(x) { return (x < 0.0) ? -1 : 1; },

  // Math.asin w/o rounding errors
  asinz : function(x) {
    if (Math.abs(x)>1.0) {
      x=(x>1.0)?1.0:-1.0;
    }
    return Math.asin(x);
  },

  // adjust longitude to -180 to 180 in radians
  adjust_lon: function(x) {
    return (Math.abs(x) < CSCS.PI) ? x : (x-(CSCS.sign(x)*CSCS.TWO_PI));
  }

};  // CSCS Namespace
